import {Component} from '@angular/core';
import {IonicPage, NavController, NavParams, ViewController} from 'ionic-angular';
import {DailyWorkerScheduleTemplateSlot} from "../../model/ReportingSlots";

/**
 * Generated class for the OrderEditDwstModalPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-order-edit-dwst-modal',
  templateUrl: 'order-edit-dwst-modal.html',
})
export class OrderEditDwstModalPage {

  private indexOfSlot: number;
  private slotDisplayName: string;
  private slots: DailyWorkerScheduleTemplateSlot[];

  constructor(public navCtrl: NavController, public navParams: NavParams, public viewCtrl: ViewController) {
  }

  ionViewDidLoad() {
    this.slots = this.navParams.get('slots');
    this.indexOfSlot = this.navParams.get('indexOfSlot');
    this.slotDisplayName = this.navParams.get('slotDisplayName');
  }

  slotPicked(sl: DailyWorkerScheduleTemplateSlot) {
    return this.viewCtrl.dismiss({templateSlot: sl});
  }
}



// WEBPACK FOOTER //
// ./src/pages/order-edit-dwst-modal/order-edit-dwst-modal.ts